export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/education_training.f2a5a48.svg";